import script from "./AppWeather.vue?vue&type=script&setup=true&lang=js"
export * from "./AppWeather.vue?vue&type=script&setup=true&lang=js"

import "./AppWeather.vue?vue&type=style&index=0&id=01aaa4f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01aaa4f0"]])

export default __exports__